//Models
PJQ.models.dailyReports.Delivery = PJQ.models.BaseModel.extend({
	idAttribute: 'deliveryId',
	notifyName: 'Delivery',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'deliveries',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.deliveryFrom) {
				this.deliveryFrom = new PJQ.models.projectContacts.ProjectContact(model.deliveryFrom);
			}
			else{
				this.deliveryFrom = null;
			}

			this.attachments = new PJQ.collections.dailyReports.DeliveryAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('deliveryFrom', this.deliveryFrom);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.DeliveryAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'delivery',
				value: this.get('deliveryId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.Deliveries = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Delivery
});

PJQ.collections.dailyReports.DeliveryAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.DeliveryAttachment
});